<template>
    <main class="bg--blue">
        <vue-headful title="ABL Groupe | Contact" />
        <div class="container bg--blue">
            <h1 class="title--white">Contact</h1>
            <section class="contacts">
                <form action="/send" class="coordonnees--form col-xs-12 col-md-5">
                    <label for="email">Courriel</label>
                    <input type="text" id="email" name="email">
                    <label for="subject">Sujet</label>
                    <input type="text" name="sujet" id="subject">
                    <label for="message">Message</label>
                    <textarea name="message" id="message" cols="30" rows="10"></textarea>
                    <input type="submit" value="Envoyer" id="send-button" class="col-xs-3">
                </form>
                <div class="map col-xs-12 col-md-5">
                    <iframe class="col-xs-12" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2623.824540809288!2d2.4137045153473538!3d48.880621307095765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66d0991c3f21d%3A0x68f236ad729bd492!2s14+Rue+Esther+Cuvier%2C+93260+Les+Lilas!5e0!3m2!1sfr!2sfr!4v1477326162217" width="500" height="500" frameborder="0" style="border:0" allowfullscreen></iframe>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
    export default {
        name: "Contact"
    }
</script>

<style lang="scss" scoped>

    //========= CONTACT ========== //

    .contacts {
        display: flex;
        flex-wrap: wrap;
        color: #ffffff;
        justify-content: space-around;
    & .coordonnees--form {
          display: flex;
          flex-direction: column;
            label {
                margin-bottom: 10px;
            }
            input {
                margin-bottom: 35px;
                border: 2px solid #ffffff;
                background: rgba(0, 0, 0, 0);
                color: #ffffff;
                padding: 10px;
            }
            textarea {
                margin-bottom:  30px;
                background: rgba(0, 0, 0, 0);
                border: 2px solid #ffffff;
                color: #ffffff;
            }
            input[type=submit] {
                padding: 5px 10px;
                flex-basis: 8%;
            }
        }
    }

    //========END CONTACT=========//
</style>